export const ENHANCED_CONVERSION_VALUE_BY_PERMALINK = {
  'creation-sas': 400,
  'creation-sasu': 400,
  'creation-sarl': 400,
  'creation-eurl': 400,
  'creation-sci': 300,
}



// WEBPACK FOOTER //
// ./src/constants/trackingData.js